import styled from 'styled-components/macro';

export const DashboardWarning = styled.div`
  font-size: 14px;
  color: #b30539;
  width: 270px;
`;
